import { createGate } from "effector-react";
const FTLSmartTableGate = createGate();
export default FTLSmartTableGate;
//# sourceMappingURL=FTLSmartTableGate.js.map